import React from "react";
import plusEightTeen from "../assets/images/18+.png";
import sunahip from "../assets/images/SUNAHIP.svg";
import logoPeru from "../assets/images/minceturLogo.jpg";
import GCB from "../assets/images/LOGOGCBverde.svg";

import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectDetectedCountry } from "../features/user/userSlice";

const Container = styled.div`
  display: ${(props) => (props.mobile ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 768px) {
    display: ${(props) => (props.mobile ? "flex" : "none")};
    margin-bottom: ${(props) => (props.mobile ? "2rem" : "0")};
  }
`;
const DivNormal = styled.div`
  width: 70px;
  height: 70px;
  margin: 0 1rem;

  @media screen and (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;

const DivLarge = styled.div`
  width: 150px;
  height: 80px;
  margin: 0 1rem;

  &.peru {
    width: 200px;
    height: 45px;
  }

  @media screen and (min-width: 972px) and (max-width: 1037px) {
    &.peru {
      margin-right: -1px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 972px) {
    &.peru {
      width: 170px;
      margin-right: -3px;
    }
  }

  @media screen and (max-width: 768px) {
    width: 90px;
    height: 60px;

    &.peru {
      width: 170px;
      margin-right: -3px;
    }
  }
`;
const DivLargeMedium = styled.div`
  width: 80px;
  height: 90px;
  margin: 0 1rem;

  @media screen and (max-width: 768px) {
    width: 70px;
    height: 70px;
  }
`;
const FooterLogos = ({ mobile }) => {
  const country = useSelector(selectDetectedCountry);

  return (
    <Container mobile={mobile}>
      <DivLarge className={country.toUpperCase() === "PE" ? "peru" : null}>
        {(country === "PE" || country === "VE") && (
          <img
            src={country.toUpperCase() !== "PE" ? sunahip : logoPeru}
            alt=""
          />
        )}
      </DivLarge>
      {country.toUpperCase() !== "PE" && (
        <DivLargeMedium>
          <a
            href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJakJYVWk5MldFWlJOSE5zTVZKdWQySjRVRGcwU1djOVBTSXNJblpoYkhWbElqb2ljVVZGUzBWaVowcDZiMUUwT1VWVVR5OTNUUzlYVDBsNU5HWmFWeTlRVVdOeE5WQlhTVFp4TlhaVFFUMGlMQ0p0WVdNaU9pSTNOMlExT0RBMU1XRXpORFkwTkdaalltVXpabVJqWkRBMU1tRXpPVGcxWlRRMFpUUm1Oakl4WXpjNU5UazFZemN6WVdRMFpEZzROR1E1TVRZeFpERTVJaXdpZEdGbklqb2lJbjA9"
            target="_blank"
          >
            <img src={GCB} alt="" />
          </a>
        </DivLargeMedium>
      )}
      <DivNormal>
        <img src={plusEightTeen} alt="" />
      </DivNormal>
    </Container>
  );
};

export default FooterLogos;
